import { render } from "./Alert.vue?vue&type=template&id=0f81cb0a&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=0f81cb0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f81cb0a"

export default script